import React from 'react';

class Alert extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={`Alert--align-${this.props.align}`}>
        <div className={`Alert Alert--${this.props.type}`}>{this.props.children}</div>
      </div>
    );
  }
}

Alert.propTypes = {
  children: React.PropTypes.string,
  type: React.PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
  align: React.PropTypes.oneOf(['right', 'left', 'center', 'none'])
};

Alert.defaultProps = {
  align: 'none',
  type: 'info'
};

export default Alert;



// WEBPACK FOOTER //
// ./src/js/components/Alert.js